import React from 'react';
import Plan from './Plan';
import style from './Plan.module.scss';
import { IPlan } from '../../model';

interface IProps {
  plans: IPlan[];
}

const Plans = (
  {
    plans
  }: IProps
) => {
  return <div className={style.plans__wrapper}>
    <div className={style.plans}>
      {plans.map((plan) => <Plan key={plan.plan_id} plan={plan}/>)}
    </div>
  </div>
};

export default Plans;
